import React, { useLayoutEffect, useRef, useState } from "react";
import ButtonBack from "../Buttons/ButtonBack";
import './index.scss';

const WiwHeaderTitle = ({ title, onBack, backLabel, preserveCase = false }) => {
  const titleRef = useRef(null);
  const [overflow, setOverflow] = useState({ left: false, right: false });

  useLayoutEffect(() => {
    const element = titleRef.current;
    const text = element?.firstElementChild;
    if (!element || !text) return undefined;
    let active = true;
    const measure = () => {
      if (!active) return;
      const box = element.getBoundingClientRect();
      const content = text.getBoundingClientRect();
      const next = {
        left: content.left < box.left + element.clientLeft - 1,
        right: content.right > box.left + element.clientLeft + element.clientWidth + 1,
      };
      setOverflow(previous => previous.left === next.left && previous.right === next.right ? previous : next);
    };
    measure();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    observer?.observe(element);
    observer?.observe(text);
    element.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    document.fonts?.ready.then(measure);
    return () => {
      active = false;
      observer?.disconnect();
      element.removeEventListener('scroll', measure);
      window.removeEventListener('resize', measure);
    };
  }, [title]);

  return (
    <div className="wiwHeader wiwHeader-title">
      <div className="wiwHeader-title-row">
        <div className="wiwHeader-title-back">
          <ButtonBack onClick={onBack} label={backLabel} />
        </div>
        <div className="wiwHeader-title-caption" data-fade-left={overflow.left} data-fade-right={overflow.right}>
          <div ref={titleRef} className={`pageName${preserveCase ? ' pageName--verbatim' : ''}`} role="heading" aria-level={1} tabIndex={0} title={typeof title === 'string' ? title : undefined}>
            <span>{title}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WiwHeaderTitle;
